var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.mergedClass, style: _vm.mergedStyle }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column h-100" },
      [
        _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
          _c("div", { staticClass: "flex-grow-1" }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("dashboard.auditHistory.timespan")) +
              "\n      "
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dateFromAsString,
                expression: "dateFromAsString"
              }
            ],
            staticClass: "form-control ml-2",
            staticStyle: { width: "15em" },
            attrs: { type: "date" },
            domProps: { value: _vm.dateFromAsString },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.dateFromAsString = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dateToAsString,
                expression: "dateToAsString"
              }
            ],
            staticClass: "form-control ml-2",
            staticStyle: { width: "15em" },
            attrs: { type: "date" },
            domProps: { value: _vm.dateToAsString },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.dateToAsString = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("LineChart", {
          staticClass: "flex-grow-1",
          attrs: { entries: _vm.filteredHistory }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }